import { useApiJobs } from './modules/apiJobs'
import { useApiJobsExternalProvider } from './modules/apiJobsExternalProvider'

export const useApiService = async (payload) => {
  const { api } = payload

  switch (api) {
    case 'apiJobs':
      return await useApiJobs({ ...payload })

    case 'apiJobsExternalProvider':
      return await useApiJobsExternalProvider({ ...payload })

    default:
      return await useApiJobs({ ...payload })
  }
}
